module.exports = __webpack_public_path__ + "kudos_22.svg?fc56ca18eb33b993c6231b276f29e636";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_22.svg
// module id = 120
// module chunks = 0